import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import Cookies from 'js-cookie';
import { AnyAction } from 'redux';
import { convertKeysToCamelCase, decryptData, encryptData } from '../../../utils/encryptDecryptUtility';

import * as actions from '../../actions/authAction';
import { AuthRequestDetail, AuthTokenDetail, GoogleAuthAction, GoogleAuthPayload, OtpRequestDetail } from '../../models/authModel';

import actionTypes from '../../types/authTypes';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { setAllPayers, setReimbursementPayers, setGrievancePayers } from '../../actions/payerListAction';
import SendRequest from '../../../shared/services/sendRequest.service';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { Payer } from '../../../shared/models/payer.model';
import { Modal } from 'antd';
import { setApplicationDetailsRedux, setHipID } from '../../actions/applicationDetailAction';
import { fetchHospitalProfileData, setIsLogOutBtnClicked, setIsLogOutClicked } from '../../actions/hospitalAction';
import { GOOGLE_AUTH, authFeatureConstants, COMMON_ERROR, PASSWORD_EXPIRED_ERROR, GOOGLE_OAUTH_CONSTANTS } from '../../../shared/constants/commonConstants';
import { canActivate, centeredNotification } from '../../../utils/utility';
import { googleAuthService } from '../../../shared/services/googleAuth.service';
import ipConfig from '../../../config/inPatientListDefaultConfig.json';
import reconConfig from '../../../config/ReconciliationDefaultConfig.json';
import claimsDisplayConfig from '../../../config/ClaimsDisplayDefaultConfig.json';
import grievanceDefaultConfig from '../../../config/grievanceDefaultConfig.json';
import reportingDefaultConfig from '../../../config/reportingDefaultConfig.json';
import AuthFailedComponent from '../../../shared/components/AuthFailedComponent/AuthFailedComponent';
// import AskNotificationPermission from '../../../utils/AskNotificationPermission';
import { decryptText, encryptText } from '../../../utils/encryptDecrypt';
import { setMetricsPayers } from '../../actions/dashboardAction';
import { customGTMEvent, reArrangeOptions } from '../../../modules/crm/inPatient/service/crmUtils';
import _ from 'lodash';
import clevertap from 'clevertap-web-sdk';
import { RANDOM_GENERATED_TOKEN_V2 } from '../../../../src/shared/constants/commonConstants';
import { ABDM_ENDPOINTS } from '../../../modules/abdmHIU/abdmConstants';
import { setIsFilteredPopoverVisible } from '../../actions/inPatientAction';
export function* logoutSaga(): any {
  try {
    const token = yield Cookies.get('r2_dto');
    if (token) {
      yield SendRequest.instance.post(`${GLOBAL_URL.CRM_BASE_URL}Provider/Provider/LogOut`, {});
    }
  } catch (e) { } finally {
    yield Cookies.remove('r2_dto');
    yield put(fetchHospitalProfileData(null));
    yield localStorage.clear();
    yield put(actions.logoutSucceed());
  }
}

function setApplicationDetail(detail: any): any {
  const appDetail = ApplicationDetail.instance;
  appDetail.setApplicationDetail(detail);
}
function* fetchUserDetail(
  reqPayload: OtpRequestDetail | AuthRequestDetail | AuthTokenDetail | GoogleAuthPayload | any,
): any {
  yield put(actions.authStart());
  const { onTwoFactorAuth } = reqPayload || {};
  delete reqPayload['onTwoFactorAuth'];
  // delete reqPayload['isChangePassword'];

  const encryptedUserName = encryptData(reqPayload.userName);
  const encryptedPassword = encryptData(reqPayload.password);
  const refreshToken = reqPayload.refreshToken; // added request for internal login and otp login as well
  const encryptedTokenObj = reqPayload.encryptedToken;
  const otp = reqPayload.otp;
  const { authMode } = reqPayload;
  const encrypReq = {
    encryptedUserName,
    encryptedPassword,
    refreshToken,
    encryptedToken: encryptedTokenObj,
    otp,
  };
  const { isInteractiveLogin } = reqPayload || {};

  const { REACT_APP_IS_LOGIN_RESPONSE_SAVE_IN_LOCAL: IS_LOGIN_RESPONSE_SAVE_IN_LOCAL } = process.env || {};
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Login`;
  try {
    const response = authMode === GOOGLE_AUTH ?
      yield sendRequest.post<any, any>(url, reqPayload) :
      yield sendRequest.post<any, any>(url, encrypReq);
    const { accessToken, providerDetail, errorMessage, isSuccess, masterDataVersion, isTwoFactorEnabled, encryptedToken,
      isEmailVerificationRequired, waitTimeToResendOTPInSec, isOTPRequestLimitExhausted } = response;

    if (!isSuccess) {
      if (errorMessage === PASSWORD_EXPIRED_ERROR) {
        yield put(actions.passwordExpired(reqPayload?.userName));
        return;
      } else if (authMode === GOOGLE_AUTH) {
        if ( !isInteractiveLogin ) {
          googleAuthService.forceInteractiveLogin();
          return;
        } else {
          yield put(actions.authFail(response.errorMessage));
          return;
        }
      } else {
        errorMessage ?
          centeredNotification(errorMessage) :
          centeredNotification('Auth failed', 'error', AuthFailedComponent);
        yield put(actions.authFail(response.errorMessage));
        return;
      }
    } else {
      yield localStorage.setItem(
        'isEmailVerificationRequired', isEmailVerificationRequired);
    }
    if (isSuccess && isTwoFactorEnabled && encryptedToken) {
      yield put(actions.setOtpFlowLoader(false));
      {
        response?.userDetail?.emailId &&
          (yield localStorage.setItem('userEmail', response?.userDetail?.emailId));
      }
      yield put(actions.setOtpTimerLimit(waitTimeToResendOTPInSec));
      yield put(actions.setIsOtpLimitExhausted(isOTPRequestLimitExhausted));
      return onTwoFactorAuth(encryptedToken);
    }

    // if(isSuccess && isChangePasswordRequired && encryptedToken) {
    //   return isChangePassword(encryptedToken)
    // }
    const { userDetail: { properties = {} } } = response;
    let { userDetail } = response;
    const decryptedUserRoles = decryptData(userDetail.encryptedUserRoles);
    const decryptedFeatures = decryptData(userDetail.encryptedFeatures);
    userDetail.userRoles = convertKeysToCamelCase(JSON.parse(decryptedUserRoles));
    userDetail.features = convertKeysToCamelCase(JSON.parse(decryptedFeatures));
    yield localStorage.setItem('isShowNotificationIcon',
      providerDetail?.providerConfigurableProperties?.isNotificationEnabled);
    yield put (setIsFilteredPopoverVisible(providerDetail?.providerConfigurableProperties?.isFilteredPopoverVisible));
    yield localStorage.setItem('isNotificationEnabled',
      providerDetail?.providerConfigurableProperties?.isNotificationEnabled && userDetail?.isNotificationEnabled);
    const { InPatientSearchParamList, ReconciliationSelectedColumns,
       ClaimsDisplayParamList, ClaimViewSearchParamList, PreAuthViewSearchParamList, GrievanceSearchParamList,
       ReportingSearchParamList, ReportingTATConfigList,
       } = properties || {};
      userDetail = {
        ...userDetail,
        properties: {
          ...userDetail.properties,
          InPatientSearchParamList: InPatientSearchParamList ? JSON.parse(InPatientSearchParamList) : ipConfig,
          GrievanceSearchParamList: GrievanceSearchParamList ? JSON.parse(GrievanceSearchParamList) : grievanceDefaultConfig,
          ReconciliationSelectedColumns: ReconciliationSelectedColumns ? JSON.parse(ReconciliationSelectedColumns) : reconConfig,
          ClaimsDisplayParamList: ClaimsDisplayParamList ? JSON.parse(ClaimsDisplayParamList) : claimsDisplayConfig,
          ClaimViewSearchParamList: ClaimViewSearchParamList ? JSON.parse(ClaimViewSearchParamList) : ipConfig,
          PreAuthViewSearchParamList: PreAuthViewSearchParamList
           ? JSON.parse(PreAuthViewSearchParamList) : ipConfig,
          ReportingSearchParamList: ReportingSearchParamList ? JSON.parse(ReportingSearchParamList)
           : reportingDefaultConfig,
          ReportingTATConfigList: ReportingTATConfigList ? JSON.parse(ReportingTATConfigList)
           : reportingDefaultConfig,
        },
      };
    yield Cookies.set('r2_dto',
      process.env.REACT_APP_RANDOM_GENERATED_TOKEN || RANDOM_GENERATED_TOKEN_V2, { secure: true, sameSite: 'Strict' });

    let updatedGroupProviders: any = [];
    if (IS_LOGIN_RESPONSE_SAVE_IN_LOCAL && userDetail && providerDetail) {
      const { groupProviders = [] } = providerDetail;
      delete providerDetail.groupProviders;
      updatedGroupProviders =
        (groupProviders || [])?.map((d: any): any => {
          return {
            key: `${d['providerId']}`,
            value: d['providerName'],
            ...d,
          };
        });

      yield localStorage.setItem(
        'userDetail',
        encryptText(JSON.stringify(userDetail)),
      );
      // AskNotificationPermission('login', true);
      yield localStorage.setItem(
        'providerDetail',
        encryptText(JSON.stringify(providerDetail)),
      );
      yield localStorage.setItem(
        'x-md-cv',
        String(masterDataVersion),
      );

      yield localStorage.setItem(
        'groupProviders',
        JSON.stringify(updatedGroupProviders),
      );
      yield localStorage?.setItem('HospitalSeal', JSON.stringify(providerDetail?.hospitalSeal));
    }
    if (providerDetail?.providerId && canActivate(authFeatureConstants.ABDM_HIU)) {
      // Post conversion
      const payload = {
        providerid: providerDetail?.providerId,
      };
      yield put(actions.getHipIdData(providerDetail?.providerConfigurableProperties?.isVersioningPostAPIEnabled ?
        payload : providerDetail?.providerId));
    }
    yield setAllDetail(providerDetail, userDetail, accessToken, updatedGroupProviders);
  } catch (error: any) {
    centeredNotification('Auth failed', 'error', AuthFailedComponent);
    yield put(actions.authFail(error?.response?.error));
  }
}

export function* authUserSaga({
  payload: { userName, password, onTwoFactorAuth, encryptedToken, otp },
}: AnyAction): Generator<any, void, any> {
  yield fetchUserDetail({ userName, password, onTwoFactorAuth, encryptedToken, otp });
}

export function* authCheckStateSaga(): Generator<any, void, string> {
  const { REACT_APP_IS_LOGIN_RESPONSE_SAVE_IN_LOCAL: IS_LOGIN_RESPONSE_SAVE_IN_LOCAL } = process.env || {};
  const token = yield Cookies.get('r2_dto');
  if (!token) {
    yield put(actions.logout());
  } else if (IS_LOGIN_RESPONSE_SAVE_IN_LOCAL) {
    const userDetailString = yield decryptText(localStorage.getItem('userDetail') || '{}');
    const providerDetailString = yield decryptText(localStorage.getItem('providerDetail') || '{}');
    const groupProvidersString = yield localStorage.getItem('groupProviders');
    if (!userDetailString || !providerDetailString || !ipConfig) {
      yield put(actions.logout());
    } else {
      const userDetails = JSON.parse(userDetailString);
      const providerDetail = JSON.parse(providerDetailString);
      const groupProviders = JSON.parse(groupProvidersString);
      yield setAllDetail(providerDetail, userDetails, token, groupProviders);
    }
  } else {
    yield fetchUserDetail({ refreshToken: token });
  }
}
const initialiseCT = (userData: any): void => {
  if (userData) {
    // model data to CT
    const CTDatalayer = {
      'Name': userData.loginName,            // String
      'Identity': userData.userId,              // String or number
      'Email': userData.emailId,
      'Fullname': `${userData.firstName} '' ${userData.lastName}`.trim(),
      'Phone': userData.mobileNo,
      'MSG-email': true,                // Enable email notifications
      'MSG-push': true,                  // Enable push notifications
      'MSG-sms': false,                   // disable sms notifications
      'MSG-whatsapp': false,              // disable WhatsApp notifications
    };

    clevertap.init(process.env.REACT_APP_CLEVERTAP_TOKEN || '');
    clevertap.onUserLogin.push({ 'Site': CTDatalayer});
    clevertap.setLogLevel(3);
    clevertap.privacy.push({optOut: false}); // Set the flag to true, if the user of the device opts out of sharing their data
    clevertap.privacy.push({useIP: true});  // Set the flag to true, if the user agrees to share their IP data
  }
};

function* setAllDetail(providerDetail: any, userDetails: any, token: string, groupProviders: any): Generator {
  yield setDefaultPayer(providerDetail, function* (): Generator {
    yield put(
      setApplicationDetailsRedux({
        userDetail: userDetails,
        hospitalDetail: providerDetail,
        groupProviders,
      }),
    );
    const Hip_Id = localStorage?.getItem('HIP_ID');
    yield put(setHipID(Hip_Id));

    const { features = [] } = userDetails || {};
    const featureList: any = {};
    features?.map(({ featureName }: any): any => {
      featureList[featureName] = true;
      return featureList;
    });
    setApplicationDetail({ userDetails, providerDetail, featureList, groupProviders });
    customGTMEvent({
      event: 'Login to Provider Platform',
    });
    initialiseCT(userDetails);
    yield put(actions.authSuccess(token));
    yield put(setIsLogOutClicked(false));
    yield put(setIsLogOutBtnClicked(false));

    // Handle deeplink redirect after successful authentication
    const deeplinkDestination = sessionStorage.getItem(GOOGLE_OAUTH_CONSTANTS.STORAGE_KEYS.DEEPLINK);
    const redirectPath = deeplinkDestination;

    if (redirectPath && redirectPath !== '/') {
      // Redirect to the stored deeplink path
      window.location.href = redirectPath;
      // Clear storage key after use
      sessionStorage.removeItem(GOOGLE_OAUTH_CONSTANTS.STORAGE_KEYS.DEEPLINK);
    }
  });
}

function* setDefaultPayer({ configuredPayers = [], defaultConfiguredPayerId, reimbursmentPayer = [] }: any, callback: () => {}): Generator {
  configuredPayers = configuredPayers?.map((payer: Payer): Payer => ({
    ...payer,
    value: payer.uniqueIdentifier,
    key: payer.uniqueIdentifier,
  }));

  reimbursmentPayer = reimbursmentPayer?.map((payer: Payer): Payer => ({
    ...payer,
    value: payer.uniqueIdentifier,
    key: payer.uniqueIdentifier,
  }));

  const grievancePayers = configuredPayers?.filter(({ isGrievanceEnabled }: any): Payer =>
    isGrievanceEnabled)?.map((payer: Payer): Payer => ({
      ...payer,
      value: payer?.uniqueIdentifier,
      key: payer?.uniqueIdentifier,
    }));

  yield put(setAllPayers(configuredPayers));
  yield put(setReimbursementPayers(reimbursmentPayer));
  yield put(setGrievancePayers(grievancePayers));
  yield callback();
}

export function* changePasswordSaga({ payload: { userName, oldPassword, newPassword, onSuccess } }: AnyAction): any {
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/ChangePassword`;
  const encryptedUserName = encryptData(userName);
  const encryptedOldPassword = encryptData(oldPassword);
  const encryptedNewPassword = encryptData(newPassword);
  const changePasswordEncrypted = {
    encryptedUserName,
    encryptedOldPassword,
    encryptedNewPassword,
  };
  try {
    const response = yield sendRequest.post(url, changePasswordEncrypted);
    if (!response.isSuccess) {
      centeredNotification(generateContent(response.errors));
      return;
    }
    Modal.success({
      title: 'Success',
      content: 'Password changed successfully',
    });
    onSuccess();
  } catch (err: any) {
    console.error(err);
    centeredNotification(COMMON_ERROR);
  }
}

const generateContent = (messages: string[]): string => {
  return messages.join('/n');
};

export function* ssoLogin({ payload: { token } }: any): Generator<any> {
  yield fetchUserDetail({ refreshToken: token });
}

function* searchHospitals({ payload: { searchString: hospitalSearchKey, onSuccess, onFailure } }: any): Generator<any> {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/HospitalSearch`;
  const sendRequest = SendRequest.instance;
  try {
    const { isSuccess, providerList }: any = yield sendRequest.post(url, { hospitalSearchKey }, undefined, undefined, false);
    if (!isSuccess) {
      onSuccess([]);
    } else {
      onSuccess(providerList);
    }
  } catch (err) {
    centeredNotification(COMMON_ERROR);
  }
}

function* getHospDetailSaga({ payload: { entityId, onSuccess, onError } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/HospitalDetals`;
  const sendRequest = SendRequest.instance;
  const hospDetailReq = {
    entityIDs: entityId,
  };
  try {
    const { providerDetails, errorMessage, isSuccess }: any = yield sendRequest.post(url, hospDetailReq);
    if (isSuccess) {
      onSuccess(providerDetails[0] || {});
    } else {
      onError(errorMessage || COMMON_ERROR);
    }
  } catch (e) {
    onError(COMMON_ERROR);
  }
}
function* getHospDetailPayerSaga({ payload: { entityId } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/HospitalDetals`;
  const sendRequest = SendRequest.instance;
  const hospDetailReq = {
    entityIDs: entityId,
  };
  try {
    const { providerDetails, isSuccess }: any = yield sendRequest.post(url, hospDetailReq);
    if (isSuccess) {
      let configuredAllPayers: any = [];
      const result = providerDetails?.map((ele: any): any => ele?.configuredPayers);
      result?.forEach((elements: any[]): void => {
        elements.forEach((element: any): void => {
          configuredAllPayers = configuredAllPayers?.concat(element);
        });
      });
      const uniquePayers = _.uniqBy(configuredAllPayers, (ele: any): any => ele?.uniqueIdentifier);
      const reArrangedPayers =
        reArrangeOptions(
          uniquePayers,
          'uniqueIdentifier',
          'name',
          { isRestRequired: true },
        );
      yield put(setMetricsPayers(reArrangedPayers));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* getSurveyQuestionsSaga(payloadData: any): Generator {
  const userDetail = decryptText(localStorage.getItem('userDetail') || '{}');
  const userId = userDetail && JSON.parse(userDetail).userId;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Survey?id=${userId}&providerid=${payloadData?.payload}`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.get(url);
    yield put(actions.getSurveyQuestionsSuccess(response));

  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* saveSurveyQuestionsSaga({ payload }: any): Generator {
  const { doLater } = payload;
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/Survey/SubmitSurvey`;
  try {
    const response: any = yield sendRequest.post(url, payload);
    if (!response.isSuccess) {
      centeredNotification(generateContent(response.errors));
      return;
    }

    if (!doLater) {
      yield put(actions.saveSurveySuccess({
        isSuccess: true,
        message: 'Survey saved successfully',
      }));
    }
  } catch (err: any) {
    centeredNotification(err || COMMON_ERROR);
  }
}

function* setUserAuthData({ payload }: any): Generator {
  const { providerDetail } = payload;
  const appService = ApplicationDetail.instance;
  const userDetails = appService.getUserDetail();
  const accessToken = appService.getAccessToken();
  const groupProviders = appService.getGroupProviders();
  yield setAllDetail(providerDetail, userDetails, accessToken, groupProviders);
}

function* getUserPerformanceSaga({ payload }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/Search/UserPerformanceCardDetails`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(url, payload);
    const { errorMessage = '', isSuccess } = response || {};
    if (isSuccess) {
      yield put(actions.getUserPerformanceSuccess(response || {}));
    } else {
      centeredNotification(errorMessage || COMMON_ERROR);
      yield put(actions.getUserPerformanceSuccess({}));
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* incorrectEmailSaga({ payload: { payload, onSuccess } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/EmailVerification`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess } = response;
    if (isSuccess) {
      onSuccess();
    }

  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* emailVerificationSkippedSaga({ payload: { payload, onSuccess } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/EmailVerification`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess } = response;
    if (isSuccess) {
      onSuccess();
    }

  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* correctEmailSaga({ payload: { payload, onSuccess } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/EmailVerification`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess, encryptedToken } = response;
    if (isSuccess) {
      onSuccess(encryptedToken);
    }

  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* emailVerificationVerifyOtpSaga({ payload: { payload, onSuccess, onError } }: any): Generator {
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/EmailVerification`;
  const sendRequest = SendRequest.instance;
  try {
    const response: any = yield sendRequest.post(url, payload);
    const { isSuccess, errorMessage } = response;
    if (isSuccess) {
      onSuccess();
    } else {
      onError(errorMessage);
    }
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* getHipHiu(payloadData: any): Generator {
  const getUrl = `${GLOBAL_URL.CRM_BASE_URL}${ABDM_ENDPOINTS?.['getHipHiuDetails']}?providerid=${payloadData?.payload}`;
  const postUrl = `${GLOBAL_URL.CRM_BASE_URL}${ABDM_ENDPOINTS?.['getHipHiuDetails']}`;
  const providerDetail = JSON?.parse(localStorage?.getItem('providerDetail') || '{}');
  try {
    let response: any;
    if (providerDetail?.providerConfigurableProperties?.isVersioningPostAPIEnabled) {
      // Make the POST request if IsVersioningGetAPIEnabled is true
      response = yield SendRequest.instance.post(postUrl, payloadData?.providerid);
    } else {
      // Make the GET request if IsVersioningGetAPIEnabled is false
      response = yield SendRequest.instance.get(getUrl);
    }
    const { id } = response;
    yield localStorage.setItem(
      'HIP_ID', (id),
    );
    const Hip_ID = localStorage?.getItem('HIP_ID');
    yield put(setHipID(Hip_ID));
  } catch (e) {
    centeredNotification(COMMON_ERROR);
  }
}

function* googleAuthSaga(action: GoogleAuthAction): Generator {
  yield fetchUserDetail(action.payload);
}

export function* watchAuth(): any {
  yield takeEvery(actionTypes.SET_USER_AUTH_DATA, setUserAuthData);
  yield takeEvery(actionTypes.CHANGE_PASSWORD, changePasswordSaga);
  yield takeEvery(actionTypes.AUTH_INITIATE_LOGOUT, logoutSaga);
  yield takeEvery(actionTypes.AUTH_USER, authUserSaga);
  yield takeEvery(actionTypes.OTP_LOGIN, authUserSaga);
  yield takeEvery(actionTypes.AUTH_CHECK_STATE, authCheckStateSaga);
  yield takeEvery(actionTypes.SSO_LOGIN, ssoLogin);
  yield takeLatest(actionTypes.SEARCH_HOSPITALS, searchHospitals);
  yield takeLatest(actionTypes.GET_HOSP_DETAIL, getHospDetailSaga);
  yield takeLatest(actionTypes.GET_HOSP_DETAIL_PAYER, getHospDetailPayerSaga);
  yield takeEvery(actionTypes.GET_SURVEY_OPTIONS, getSurveyQuestionsSaga);
  yield takeEvery(actionTypes.SAVE_SURVEY, saveSurveyQuestionsSaga);
  yield takeEvery(actionTypes.GET_USER_PERFORMANCE, getUserPerformanceSaga);
  yield takeEvery(actionTypes.INCORRECT_EMAIL, incorrectEmailSaga);
  yield takeEvery(actionTypes.SKIPPED_EMAIL_VERIFICATION, emailVerificationSkippedSaga);
  yield takeEvery(actionTypes.CORRECT_EMAIL, correctEmailSaga);
  yield takeEvery(actionTypes.EMAIL_VERIFICATION_VERIFY_OTP, emailVerificationVerifyOtpSaga);
  yield takeEvery(actionTypes.GET_HIP_HIU, getHipHiu);
  yield takeLatest(actionTypes.GOOGLE_AUTHENTICATE, googleAuthSaga);
}

export default watchAuth;
